export default __webpack_public_path__ + "static/media/pen-bg1.8e406eff.jpeg";